import * as icons from 'vue-feather-icons';

import RubleIcon from './RubleIcon';
import SberbankIcon from './SberbankIcon';
import DepartmentIcon from './DepartmentIcon';
import CompanyIcon from './CompanyIcon';
import GisIcon from './GisIcon';
import ElectricityIcon from './ElectricityIcon';
import GasIcon from './GasIcon';
import HeaterIcon from './HeaterIcon';
import WaterIcon from './WaterIcon';
import CleaningIcon from './CleaningIcon';
import FoodIcon from './FoodIcon';
import ServiceIcon from './ServiceIcon';
import FilesIcon from './FilesIcon';
import DoorIcon from './DoorIcon';
import PenIcon from './PenIcon';

icons.RubleIcon = RubleIcon;
icons.SberbankIcon = SberbankIcon;
icons.DepartmentIcon = DepartmentIcon;
icons.CompanyIcon = CompanyIcon;
icons.GisIcon = GisIcon;
icons.ElectricityIcon = ElectricityIcon;
icons.GasIcon = GasIcon;
icons.HeaterIcon = HeaterIcon;
icons.WaterIcon = WaterIcon;
icons.CleaningIcon = CleaningIcon;
icons.FoodIcon = FoodIcon;
icons.ServiceIcon = ServiceIcon;
icons.FilesIcon = FilesIcon;
icons.DoorIcon = DoorIcon;
icons.PenIcon = PenIcon;